import { icon_fold_on } from 'components/base/images';
import React, { useState, useRef } from 'react';
import { useController, Control } from 'react-hook-form';
import styled from 'styled-components';
import cx from 'classnames';
import CustomText from '../text/CustomText';
import useOutsideClick from 'lib/hooks/useOutsideClick';

interface DropdownControllerProps {
  control: Control;
  name: string;
  options: { value: string; label: string }[]; // 드롭다운 옵션을 받는 props
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
}

function DropdownController({
  control,
  name,
  options,
  placeholder = '',
  disabled = false,
  required = false,
}: DropdownControllerProps) {
  const {
    field,
    meta: { invalid },
  } = useController({
    name,
    control,
    rules: { required: required },
  });

  const [isListOpen, setIsListOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleList = () => {
    setIsListOpen(!isListOpen);
  };

  const handleOptionClick = (value: string) => {
    field.onChange(value);
    setIsListOpen(false);
  };

  useOutsideClick({
    ref: dropdownRef,
    handler: () => setIsListOpen(false),
  });

  return (
    <StyledDropdownController ref={dropdownRef}>
      <button
        type="button"
        className="dropdownController__button"
        disabled={disabled}
        placeholder={placeholder}
        onClick={toggleList}
      >
        <CustomText fontSize={20} fontWeight={400} color="#222">
          {options.find(option => option.value === field.value)?.label || ''}
        </CustomText>

        <img
          src={icon_fold_on}
          className={cx('icon_arrow', {
            open: isListOpen,
            closed: !isListOpen,
          })}
        />
      </button>

      {isListOpen && (
        <ul className="dropdownController__listbox">
          {options.map(option => (
            <li
              key={option.value}
              className="list_option"
              onClick={() => handleOptionClick(option.value)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}

      {invalid && <span style={{ color: 'red' }}>This field is required</span>}
    </StyledDropdownController>
  );
}

const StyledDropdownController = styled.div`
  position: relative;
  width: 100%;
  .dropdownController__button {
    width: 100%;
    height: 50px;
    border-radius: 2px;
    border: 1px solid #e1e1e7;
    padding: 12px;
    text-align: left;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    .icon {
      transition: transform 0.2s ease;
    }

    .open {
      transform: rotate(180deg);
    }

    &:disabled {
      background: #f9f9fb;
      color: #888;
    }
  }

  .dropdownController__listbox {
    z-index: 9999;
    position: absolute;
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.16);
    border-radius: 3px 3px 0px 0px;
    /* margin-top: 4px; */
    list-style: none;
    padding: 0;
    max-height: 200px;
    overflow-y: auto;

    .list_option {
      padding: 14px;
      cursor: pointer;
      &:hover {
        background-color: #eef9fd;
      }
    }
  }

  span {
    color: red;
    font-size: 12px;
  }
`;

export default DropdownController;
